var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { VBox } from "../structural_components/hbox_vbox";
import { Label, DescriptionLabel, ErrorLabel } from "./label";
import { createControlId } from "./id_creator";
import { bind } from "./control";
import { createEntityFieldGetter } from "../state/entity";
import { getFieldErrorsAsString } from "../validation/validatableentity";
import { cls_input } from "./base_input_field.css";
import { cls_form_item_box } from "./form_item.css";
import { getIsoStringDate, isValidDate, join } from "framework/helpers";
import { Tooltip, TooltipContentBox } from "./tooltip";
import { useif } from "framework/state/types";
import { cls_error, cls_error_label_elem, cls_error_tooltip_elem } from "./controls.css";
import { cls_display_none } from "style/index.css";
var InputFieldBase = function (props) {
    var label = props.label, description = props.description, error = props.error, getter = props.getter, setter = props.setter, props_other = __rest(props, ["label", "description", "error", "getter", "setter"]);
    var id = createControlId();
    var binding = bind(props);
    var value = binding.value ? getIsoStringDate(binding.value) : '';
    var _a = React.useState(null), localError = _a[0], setLocalError = _a[1];
    var error_tooltip_content = error ? React.createElement(TooltipContentBox, { className: [useif(!props.errorAsTooltip, cls_display_none), cls_error_tooltip_elem] },
        React.createElement(ErrorLabel, null, error)) : null;
    var error_label = error ? React.createElement(ErrorLabel, { className: [useif(props.errorAsTooltip, cls_display_none), cls_error_label_elem] }, error) : null;
    var cls = join(cls_input, props.className, useif(error || localError, cls_error));
    var handleChange = function (e) {
        var new_date = new Date(e.target.value);
        if (isValidDate(new_date)) {
            binding.onChange(new_date);
            setLocalError(false);
        }
        else {
            setLocalError(true);
        }
    };
    var ref = React.useRef(null);
    React.useEffect(function () {
        if (ref.current.value !== value) {
            ref.current.value = value;
        }
    }, [value]);
    return React.createElement(VBox, { className: cls_form_item_box },
        label ? React.createElement(Label, null, label) : React.createElement(React.Fragment, null),
        React.createElement(Tooltip, { content: error_tooltip_content },
            React.createElement("input", __assign({}, props_other, { type: "date", id: id, ref: ref, defaultValue: value, onChange: function (e) { return handleChange(e); }, className: cls, disabled: props.disabled }))),
        description ? React.createElement(DescriptionLabel, { htmlFor: id }, description) : React.createElement(React.Fragment, null),
        error_label);
};
export var DateField = function (props) {
    var _a, _b, _c;
    var getter = props.getter || createEntityFieldGetter(props.state);
    var setter = props.setter || ((_a = props.actions) === null || _a === void 0 ? void 0 : _a.setEntityField) || null;
    var error = (_c = (_b = props.error) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : (props.state && props.name ? getFieldErrorsAsString(props.state, props.name) : null);
    return React.createElement(InputFieldBase, __assign({}, props, { getter: getter, setter: setter, error: error }));
};
